import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../layout/breadcrumb'
import DprHeader from '../layout/dprHeader'
import { useLocation } from 'react-router-dom';
// import FatalityBarChart from './Example';

import { DPR_API } from '../../services/apiCalls/dprApiCalls';
import PhysicalProgressChart from '../report/overview-report';
import NCRTracker from '../report/circle-text-chart';
import Chart from '../report/innet-racker';
import CustomBarChart from '../report/Example';
import ComplaintChart from '../report/complaints-chart';
import NumberCategoryChart from '../report/number-of-category-chart';
import { PROJECT_API } from '../../services/apiCalls/projectApiCalls';
import { toast } from 'react-toastify';

export default function PortfolioReport() {
    const location = useLocation();
    const data = location.state || {};
    const [reportType, setReportType] = useState("Project Overview Reports");
    const [years, setYears] = useState([]);
    const [physicalReport, setPhysicalReport] = useState(null);
    const [ncrReport, setNcrReport] = useState(null);
    const [issueReport, setIssueReport] = useState(null);
    const [riskReport, setRiskReport] = useState(null);
    const [activityReport, setActivityReport] = useState(null);
    const [categoryReportData, setCatgoryReportData] = useState(null)
    const [fatality, setFatelity] = useState(null)
    const [totalnumberofcomplaint,setTotalnumberofcomplaint]=useState(null)
    const [lossTimeInjury, setLossTimeInjury] = useState(null)
    const [firstAidCases, setFirstAidCases] = useState(null)
    const [propertyDamage, setPropertyDamage] = useState(null);
    const [numberOfCategories,setNumberOfCategories]=useState({'data':[],'labels':[]});
    const [projectsData, setProjectsData] = useState([]);
    const [project, setProject] = useState("");

    const [reportFilter, setReportFilter] = useState({
        "Year": "",
        "Month": 1,
        "ProjectId": project,
        // "ProjectName": "",
        "Region": ""
    })

    function getLastFourYears() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i < 10; i++) {
            years.push(currentYear - i);
        }
        return years;
    }

    const dataMonth = ["abc", 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', "Aug", 'Sep', 'Oct', 'Nov', 'Dec']

    const getReports = async (filter, report) => {
        let rp=filter;
        if(report=="SafetyReport"){
        rp=filter
        }else{
            rp={
                Month:rp.Month,
                ProjectId:project,
                Year:rp.Year
            }
        }
       
        const reports = await DPR_API?.getReportsData(rp, report);
        if ((reports && reports?.Status == 200) || (reports && reports?.status==200)) {
            // if(report==="SafetyReport"){
            //     if(reports?.FatalityReports?.length){
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Fatality": reports.FatalityReports[0]?.Value }
            //         setFatelity(datas)
            //     }else{
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Fatality": 0 }
            //         setFatelity(datas)
            //     }
            //     if(reports?.LTIReports?.length){
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Lost Time Injury": reports.LTIReports[0]?.Value }
            //         setLossTimeInjury(datas)
            //     }else{
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Lost Time Injury": 0 }
            //         setLossTimeInjury(datas)
            //     }
            //     if(reports?.FirstAidReports?.length){
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "First Aid Cases": reports.FirstAidReports[0]?.Value }
            //         setFirstAidCases(datas)
            //     }else{
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "First Aid Cases": 0 }
            //         setFirstAidCases(datas)
            //     }
            //     if(reports?.PropertyDamageReports?.length){
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Property Damage": reports.PropertyDamageReports[0]?.Value }
            //         setPropertyDamage(datas)
            //     }else{
            //         let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "Property Damage": 0 }
            //         setPropertyDamage(datas)
            //     }
            // }
            if(report==="ProjectOverViewReport"){
                const label = reports?.physicalProgressReportsList?.map(val => { return val?.Name });
                const pdata = reports?.physicalProgressReportsList?.map(val => { return val?.value !== 0 ? val?.value :null });
                let phData = [];
                phData['labels'] = label
                phData['data'] = pdata;
                setPhysicalReport(phData);
                console.log("Physical Progress",phData)
                const labelncr = reports?.nCRReportList?.map(val => { return val?.Name });
                const pdatancr = reports?.nCRReportList?.map(val => { return val?.value !== 0 ? val?.value : 0 });
                let ncrData = [];
                ncrData['labels'] = labelncr
                ncrData['data'] = pdatancr;
                ncrData['total'] = reports?.nCRReportList[0]?.value;
                setNcrReport(ncrData)
                // issue tracker
                const labelissue = reports?.nCRIssueReportList?.map(val => { return val?.Name });
                const pdataissue = reports?.nCRIssueReportList?.map(val => { return val?.value !== 0 ? val?.value : null });
                let issueData = [];
                issueData['labels'] = labelissue
                issueData['data'] = pdataissue;
                issueData['total'] = reports?.nCRIssueReportList[0]?.value;
                setIssueReport(issueData)
                // risk tracker
                if (reports?.nCRRiskReportList) {
                    const labelrisk = reports?.nCRRiskReportList?.map(val => { return val?.Name });
                    const pdatarisk = reports?.nCRRiskReportList?.map(val => { return val?.value !== 0 ? val?.value : null });
                    let riskData = [];
                    riskData['labels'] = labelrisk
                    riskData['data'] = pdatarisk;
                    riskData['total'] = reports?.nCRRiskReportList[0]?.value;
                    setRiskReport(riskData)
                }
                // activityStatusReportList
                if (reports?.activityStatusReportList) {
                    const labelActivity = reports?.activityStatusReportList?.map(val => { return val?.Name });
                    const dataActivity = reports?.activityStatusReportList?.map(val => { return val?.value !== 0 ? val?.value : null });
                    let activotykData = [];
                    activotykData['labels'] = labelActivity
                    activotykData['data'] = dataActivity;
                    // riskData['total'] = reports?.activityStatusReportList[0]?.value ;
                    setActivityReport(activotykData)
                }
                // {month:`${reportFilter.Month} - ${reportFilter?.Year}`,"NCR Category Wise":10}
                if (reports?.nCRCategoryReportList) {
                    let datas = { month: `${dataMonth[parseInt(reportFilter?.Month)]}-${reportFilter?.Year}`, "NCR Category Wise": reports.nCRCategoryReportList[0]?.value }
                    setCatgoryReportData(datas)
                }
            }
            // if(report==="PostHandoverComplaintReport"){
            //     if(reports?.totalnumberofcomplaintList?.length){
            //      let data=reports?.totalnumberofcomplaintList;
            //      let datas=[{ name: `FY ${data[0]?.Year}`, registered: data[0]?.value, resolved: data[1]?.value, notResolved:  data[2]?.value }]
            //      setTotalnumberofcomplaint(datas)
            //     }else{
            //      setTotalnumberofcomplaint(null)
            //     }
            //     if(reports?.totalnumberofComplaintCategoriesList?.length){
            //         const labels=reports?.totalnumberofComplaintCategoriesList?.map(va=>{
            //             return va?.Category
            //         })
            //         const data=reports?.totalnumberofComplaintCategoriesList?.map(va=>{
            //             return va?.value
            //         })

            //         let dt=labels
            //         dt['labels']=labels
            //         dt['data']=data
            //         setNumberOfCategories(dt)
            //     }else{
            //         setNumberOfCategories({'data':[],'labels':[]})
            //     }
            // }
        }
    }

    useEffect(() => {
        setYears(getLastFourYears);
        let dt = reportFilter;
        dt['Year'] = getLastFourYears()[0];
        dt['ProjectId'] = project;
        setTimeout(() => {
            if(project==""){
                // toast.error("Select a project for reports",{autoClose:2000})
               }else{
                getReports(dt, reportType === "Project Overview Reports" ? "ProjectOverViewReport" : reportType === "Safety Reports" ? "SafetyReport" : "PostHandoverComplaintReport")
               }
            
        }, 1000);
        setReportFilter(dt)
    }, [])

    const handleChange = (event) => {
        const { name, value } = event.target;
        setReportFilter((prev) => ({ ...prev, [name]: value }));
    };

    const onSubmit = async () => {
        if(project==""){
            toast.error("Select a project for reports",{autoClose:2000})
           }else{
            // getReports(dt, reportType === "Project Overview Reports" ? "ProjectOverViewReport" : reportType === "Safety Reports" ? "SafetyReport" : "PostHandoverComplaintReport")
            getReports(reportFilter, reportType === "Project Overview Reports" ? "ProjectOverViewReport" : reportType === "Safety Reports" ? "SafetyReport" : "PostHandoverComplaintReport")
           }
    }
    const reason = ['East', "West", "North", "South"]

    const getPhReport = () => {
        return <PhysicalProgressChart data={physicalReport} />
    }

    const getNcrReport = () => {
        return <NCRTracker data={ncrReport} label="Total Ncr" />
    }
    const getIssueTracker = () => {
        console.log("nnnnn",issueReport)
        return <NCRTracker data={issueReport} label="Total Issue" />
    }

    const getactivityStatusReport = () => {
        return <Chart data={activityReport} />
    }
    const getRiskTracker = () => {
        return <NCRTracker data={riskReport} label="Total Risk" />
    }

      const getProjects = async () => {
        const projects = await PROJECT_API.getProjects();
        if (projects.status === 200) {
          setProjectsData(projects.project);
        }
      };

      useEffect(()=>{
        getProjects();
      },[])

    return <React.Fragment>
        <div className='pb-5'>
            <Breadcrumbs title="Portfolio Report" menu="" link="Portfolio Report" />
            {/* <DprHeader project={data} /> */}
            <div className="card mt-4 card-bd-none">
                <div className="card-body">
                    <div className="row">
                        <div className="col-4">
                            <div
                                className="my-3"
                                style={{
                                    color: "rgba(0, 0, 0, 1)",
                                    fontSize: 17,
                                    fontWeight: 500,
                                }}
                            >
                                Portfolio Report Filter
                            </div>
                        </div>
                        <div className="col-2">
                            <label className="filter-label">Select Project</label>
                            <select value={project} onChange={(e) => {
                                if (e.target.value === "Safety Reports") {
                                    let dt = reportFilter;
                                    dt['Region'] = "East";
                                    setReportFilter(dt)
                                } else {
                                    let dt = reportFilter;
                                    dt['Region'] = "";
                                }
                                setProject(e.target.value)
                            }}
                                className="filter-label"
                                style={{
                                    width: "100%",
                                    height: 31,
                                    border: "1px solid #e6e3e3",
                                    borderRadius: 4,
                                }}
                            >
                                <option value="">--Select Project--</option>
                                {projectsData?.map(val=><option value={val?.project_id}>{val?.Project_Name}</option>)}
                            </select>
                        </div>
                        <div className="col-1">
                            <label className="filter-label">Year</label>
                            <select onChange={handleChange} value={reportFilter?.Year}
                                name='Year'
                                className="filter-label"
                                style={{
                                    width: "100%",
                                    height: 31,
                                    border: "1px solid #e6e3e3",
                                    borderRadius: 4,
                                }}
                            >
                                {years?.map(val => {
                                    return <option value={val}>{val}</option>
                                })}

                            </select>
                        </div>
                        <div className="col-1">
                            <label className="filter-label">Month</label>
                            <div>
                                <select
                                    onChange={handleChange}
                                    value={reportFilter?.Month}
                                    name='Month'
                                    className="filter-label"
                                    style={{
                                        width: "100%",
                                        height: 31,
                                        border: "1px solid #e6e3e3",
                                        borderRadius: 4,
                                    }}
                                >
                                    {/* <option value={""}>--select month</option> */}
                                    <option value={"1"}>1</option>
                                    <option value={"2"}>2</option>
                                    <option value={"3"}>3</option>
                                    <option value={"4"}>4</option>
                                    <option value={"5"}>5</option>
                                    <option value={"6"}>6</option>
                                    <option value={"7"}>7</option>
                                    <option value={"8"}>8</option>
                                    <option value={"9"}>9</option>
                                    <option value={"10"}>10</option>
                                    <option value={"11"}>11</option>
                                    <option value={"12"}>12</option>
                                </select>
                            </div>
                        </div>
                        {reportType === "Safety Reports" ? <div className="col-1">
                            <label className="filter-label">Region</label>
                            <div>
                                <select
                                    onChange={handleChange}
                                    value={reportFilter.Region}
                                    name='Region'
                                    className="filter-label"
                                    style={{
                                        width: "100%",
                                        height: 31,
                                        border: "1px solid #e6e3e3",
                                        borderRadius: 4,
                                    }}
                                >
                                    {reason?.map(val => {
                                        return <option value={val}>{val}</option>
                                    })}
                                </select>
                            </div>
                        </div> : ""}

                        <div className="col-2">
                            <button
                                className="my-3 btn btn-primary"
                                style={{ float: "right" }}
                                onClick={onSubmit}
                            >
                                FIlter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {reportType === "Safety Reports" ? <>
                {/* <div className='row'>
                    <div className='col-6'>
                        <div className='card mt-4 card-none-b'>
                            <div className='card-body'>
                                <CustomBarChart fill="#32CD32" title="Fatality" month={fatality} />
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='card mt-4 card-none-b'>
                            <div className='card-body'>
                                <CustomBarChart fill="rgba(91, 155, 213, 1)" title="Lost Time Injury" month={lossTimeInjury} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-6'>
                        <div className='card mt-4 card-none-b'>
                            <div className='card-body'>
                                <CustomBarChart fill="rgba(251, 146, 60, 1)" title="First Aid Cases"  month={firstAidCases} />
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='card mt-4 card-none-b'>
                            <div className='card-body'>

                                <CustomBarChart fill="rgba(192, 132, 252, 1)" title="Property Damage" month={propertyDamage} />
                            </div>
                        </div>
                    </div>
                </div> */}
            </>
                : reportType === "Project Overview Reports" ? <>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div className='row'>

                                        <div className='col-6' style={{ borderRight: "1px solid rgba(217, 217, 217, 1)" }}>
                                            <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>
                                                Physical Progress
                                            </div>
                                            {physicalReport?.data[0]!=null ? getPhReport() : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                        </div>
                                        <div className='col-6'>
                                            <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>
                                                NCR Tracker
                                            </div>
                                            {ncrReport?.data[0!=null] ? getNcrReport() : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>Activity Status</div>
                                    {activityReport?.data[0]!=null? getactivityStatusReport() : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}></div>
                                    {categoryReportData!=undefined ? <CustomBarChart fill="rgba(251, 146, 60, 1)" title="NCR Category Wise" month={categoryReportData} /> : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div className='row'>

                                        <div className='col-6' style={{ borderRight: "1px solid rgba(217, 217, 217, 1)" }}>
                                            <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>
                                                Issue Tracker
                                            </div>
                                            {issueReport?.data[0]!=null ? getIssueTracker() : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                        </div>
                                        <div className='col-6'>
                                            <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>
                                                Risk Tracker
                                            </div>
                                            {riskReport?.data[0]!=null ? getRiskTracker() : <p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </> : <>
                    {/* <div className='row'>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>Total Number of complaints</div>
                                    {totalnumberofcomplaint!==null?<ComplaintChart data={totalnumberofcomplaint} />:<p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                    
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='card mt-4 card-none-b'>
                                <div className='card-body'>
                                    <div style={{ color: "rgba(0, 0, 0, 0.73)", fontSize: 14, fontWeight: 600 }}>Number of categories</div>
                                    {numberOfCategories?.data?.length?<NumberCategoryChart data={numberOfCategories} />:<p className='text-center my-5' style={{ color: 'gray', fontSize: 12, fontWeight: 600 }}>No data found</p>}
                                    
                                </div>
                            </div>
                        </div>
                    </div> */}
                </>}
        </div>
        <br /><br /><br /><br /><br /><br />
    </React.Fragment >
}
